export enum SpainIdType {
  DNI = 'dni',
  NIE = 'nie',
  PASSPORT = 'passport',
  SOCIAL_SECURITY_NUMBER = 'social_security_number',
}
